import { Card, Select, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AcademicYearApiService from '../../../../api/AcademicYearApiService';
import SecondaryProgramScenarioDataTable from '../../../../components/datatables/secondary/SecondaryProgramScenarioDataTable';
import Dropdown from '../../../../components/inputs/Dropdown';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import * as GetAcademicYearsHandler from '../../../../handlerModels/GetAcademicYearsHandler';
import AcademicYearDTO from '../../../../models/AcademicYearDTO';
import HeaderPortal from '../../../../portals/HeaderPortal';
import DateTimeUtil from '../../../../utils/DateTimeUtil';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface ScenarioConfigurationListPageState {
  loading: boolean;
  academicYear: number;
  academicYears: AcademicYearDTO[];
}

interface ScenarioConfigurationListPageProps {
}

class ScenarioConfigurationListPage extends React.Component<ScenarioConfigurationListPageProps & RouteComponentProps<RouteObject>, ScenarioConfigurationListPageState> {

  constructor(props: ScenarioConfigurationListPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      loading: false,
      academicYear: 2022,
      academicYears: [],
    };
  }

  componentDidMount() {
    this.loadAcademicYears();
  }

  private loadAcademicYears = () => {
    this.setState({ loading: true });
    const request = GetAcademicYearsHandler.Request.create({
    });
    return AcademicYearApiService.getAcademicYears(request)
      .then((results: GetAcademicYearsHandler.Result) => {
        if (results && results.academicYears) {
          this.setState({
            academicYears: results.academicYears ?? [],
            academicYear: DateTimeUtil.getCurrentYear()
          });
        }
      })
      .catch()
      .finally(() => {
        this.setState({ loading: false })
      });
  }

  private onSelect = (value: any) => {
    this.setState({ academicYear: value });
  }

  private onBack = () => {
    HistoryUtil.goBack();
  }

  render() {

    return (
      <Content >
        <HeaderPortal title='Scenarios' breadcrumbs={Breadcrumbs.ScenarioConfigurationList()}
          onBack={this.onBack}
          extra={<Dropdown value={this.state.academicYear} onSelect={this.onSelect} dropdownMatchSelectWidth={false}>{this.state.academicYears.map(x => { return this.renderAcademicYear(x); })}</Dropdown>} />
        < Space direction="vertical" size="large">
          <Card title="Scenarios">
            <Space direction='vertical' size="large">
              <SecondaryProgramScenarioDataTable
                academicYear={this.state.academicYear} />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }

  renderAcademicYear(academicYear: AcademicYearDTO) {
    return <Select.Option key={academicYear.id} value={academicYear.id}>{academicYear.id}</Select.Option>
  }
}

export default withRouter((ScenarioConfigurationListPage));
